import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useSelector } from '@grandvisionhq/state';
import { TitleWithIcon } from '../../../components/TitleWithIcon/TitleWithIcon.js';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { getSelectedShippingMethod } from '../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import { isPickupStore } from '../../../utils/shipping-method.js';
import 'history';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '../../../utils/has-cart-errors.js';

const ServiceStoreHeading = ({ shouldHideIcon =false , title , subtitle  })=>{
    const { features , serviceStore  } = useCheckoutSettings();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const isPickupStoreSelected = isPickupStore(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    if (!(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) || isPickupStoreSelected) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "store",
        shouldHideIcon: shouldHideIcon,
        label: title
    }), /*#__PURE__*/ React.createElement(Text, {
        component: "p",
        className: "checkout-step__subtitle"
    }, subtitle, !(serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.isOptional) && /*#__PURE__*/ React.createElement("span", {
        className: "service-store__asterisk"
    }, "*")));
};

export { ServiceStoreHeading, ServiceStoreHeading as default };
//# sourceMappingURL=ServiceStoreHeading.js.map
